module.exports = __webpack_public_path__ + "img/image 60.4cb23989.png";